import { BRAND } from '@/config/brand';
import type { Paise } from '@/types/domain';

const rupeeFmt = new Intl.NumberFormat(BRAND.locale, {
  style: 'currency',
  currency: BRAND.currency,
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const rupeeFmtPaise = new Intl.NumberFormat(BRAND.locale, {
  style: 'currency',
  currency: BRAND.currency,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const numberFmt = new Intl.NumberFormat(BRAND.locale);

/** Paise → "₹2,10,602" (rounded to whole rupees, en-IN grouping). */
export function formatMoney(paise: Paise): string {
  return rupeeFmt.format(Math.round(paise) / 100);
}

/** Paise → "₹3.50" (keeps two decimals; used for per-minute rates). */
export function formatMoneyPrecise(paise: Paise): string {
  return rupeeFmtPaise.format(Math.round(paise) / 100);
}

/** Rate paise-per-minute → "₹3.00 / min". */
export function formatRate(ratePerMinutePaise: Paise): string {
  return `${formatMoneyPrecise(ratePerMinutePaise)} / min`;
}

export function formatNumber(n: number): string {
  return numberFmt.format(n);
}

/** Signed percentage, e.g. -10.6 → "10.6%". Sign is shown separately by callers. */
export function formatPercent(pct: number, fractionDigits = 1): string {
  return `${Math.abs(pct).toFixed(fractionDigits)}%`;
}

export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}
